// 调拨列表每一项
import { TiTag } from "@ti/ui-mobile";
import { useT } from "@/utils/intlUtils";
import { useEnums } from "@/utils/enumsUtils";
import NumberText from "./NumberText";
import { Text } from "@/pages/transfer/components/styles";
import { getTypeMaps } from "@/pages/transfer/utils/enums";
import {
  ListItem as ListItemBox,
  Applicant,
  ApprovalNumber,
  NumberBox,
  StatusTag,
} from "./styles";

export type DataProps = {
  type: 1 | 2 | 4;
  id: number;
  //申请人
  applicantName: string;
  //申请企业
  targetCompanyName: string;
  //审批企业
  sourceCompanyName: string;
  //负责人
  principalName: string;
  materialApplyId: string;
  transferStatus: string;
  transferCode: string;
  transferApplyCode?: string;
  logisticsCode?: string;
};

type ListItemProps = {
  record?: DataProps;
  onClick: () => void;
};

const ListItem = (props: ListItemProps) => {
  const { transferStatus } = useEnums([
    { code: "transferStatus", resFormat: "object" },
  ]);

  const TypeMaps = getTypeMaps();

  const t = useT("transfer");

  const { record, onClick } = props;

  const renderOrderInfo = (row?: DataProps) => {
    switch (row?.type) {
      case 1:
        if (!row?.transferCode && !row?.logisticsCode) {
          return null;
        }
        return (
          <NumberBox>
            {row?.transferCode && (
              <NumberText
                title={t("调拨单号")}
                type="order"
                info={row?.transferCode}
              />
            )}
            {row?.logisticsCode && (
              <NumberText
                title={t("物流单号")}
                type="logistics"
                info={row?.logisticsCode}
              />
            )}
          </NumberBox>
        );
      case 2:
      case 4:
        if (!row?.transferApplyCode && !row?.logisticsCode) {
          return null;
        }
        return (
          <NumberBox>
            {row?.transferApplyCode && (
              <NumberText
                type="order"
                title={t("调拨申请单")}
                info={row?.transferApplyCode}
              />
            )}
            {row?.logisticsCode && (
              <NumberText
                title={t("物流单号")}
                type="logistics"
                info={row?.logisticsCode}
              />
            )}
          </NumberBox>
        );
      default:
        return <span>default</span>;
    }
  };

  return (
    <ListItemBox onClick={onClick}>
      <Applicant>
        {record?.targetCompanyName}-{record?.applicantName}
      </Applicant>
      <ApprovalNumber>
        <TiTag
          style={{ marginRight: 8 }}
          type="default"
          color={(record?.type && TypeMaps[record.type]["color"]) || ""}
          title={record?.type && TypeMaps[record.type]["label"]}
        />
        <Text $color="#333333" $fontSize="12px" $lineHeight="18px">
          {record?.materialApplyId}
        </Text>
      </ApprovalNumber>
      <Text
        style={{
          marginTop: 8,
          marginBottom: 8,
          display: "inline-block",
        }}
        $color="#9ea1a7"
        $fontSize="12px"
        $lineHeight="18px"
      >
        {t("审批人")}：{record?.sourceCompanyName}-{record?.principalName}
      </Text>
      {renderOrderInfo(record)}
      <StatusTag>
        <Text $color="#ff7600" $fontSize="14px" $lineHeight="24px">
          {record?.transferStatus &&
            transferStatus[record.transferStatus]?.text}
        </Text>
      </StatusTag>
    </ListItemBox>
  );
};

export default ListItem;
